import styles from './Navigation.less';

import React, { Component, PropTypes } from 'react';

import { ScreenReaderOnly } from 'seek-style-guide/react';
import ExternalLink from 'ExternalLink/ExternalLink';
import QualifiedLink from 'QualifiedLink/QualifiedLink';

export default class Navigation extends Component {

  static propTypes = {
    locale: PropTypes.string.isRequired
  };

  render() {
    const { locale } = this.props;
    const isAU = locale === 'AU';

    const $150k = isAU ?
      (<li className={styles.item}>
        <ExternalLink analytics="header:high+salary" className={styles.link} href="/150kjobs" aria-label="One fifty K jobs">$150k+ Jobs</ExternalLink>
      </li>) : null;

    const companyReviews = isAU ?
      (<li className={styles.item}>
        <ExternalLink analytics="header:companies" className={styles.link} href="/companies/">Company Reviews</ExternalLink>
      </li>) : null;

    return (
      <nav role="navigation" className={styles.root}>

        <ScreenReaderOnly>
          <h1>Main Navigation</h1>
        </ScreenReaderOnly>

        <ul className={styles.list} data-automation="nav-tabs">
          <li className={styles.item}>
            <QualifiedLink analytics="header:jobs" className={`${styles.link} ${styles.link_isActive}`} path="/">Job Search</QualifiedLink>
          </li>
          {$150k}
          <li className={styles.item}>
            <ExternalLink analytics="header:profile" className={styles.link} href="/profile/">Profile</ExternalLink>
          </li>
          {companyReviews}
          <li className={styles.item}>
            <ExternalLink analytics="header:advice" className={styles.link} href="/career-advice/">Advice &amp; Tips</ExternalLink>
          </li>
        </ul>

      </nav>
    );
  }

}



/** WEBPACK FOOTER **
 ** ./app/components/Header/components/Navigation/Navigation.js
 **/